import { BoxProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { sizePropTypes } from '../../atoms/Avatar/Avatar';
import { useMultiStyleConfig } from '../../system/hooks';
import { Box } from '../../theme';
import { InferPropTypes } from '../../types';

const propTypes = {
  count: PropTypes.number.isRequired,
  size: PropTypes.oneOf(sizePropTypes),
  staggered: PropTypes.bool
};
const defaultProps = {
  size: 'md',
  staggered: false
};

export type ExcessAvatarlabelProps = BoxProps & InferPropTypes<typeof propTypes, typeof defaultProps>;

export default function ExcessAvatarLabel(props: ExcessAvatarlabelProps): React.ReactElement {
  const { count, staggered, ...rest } = props;

  const { excessLabel } = useMultiStyleConfig('AvatarCustomTheme', { staggered, ...rest });

  return (
    <Box __css={excessLabel} aria-label="number of avatars not shown" as="span" {...rest}>
      {count}
    </Box>
  );
}

ExcessAvatarLabel.propTypes = propTypes;
ExcessAvatarLabel.defaultProps = defaultProps;
